import { FocusReport } from '@/redux/slices/slice_types';
import UserDisplay from '@/components/_common/AssigneeSelect/UserDisplay';
import { ClickCopy, DateTimeDisplay } from '@/exports/columnCommonComponents';
import { formatBytes } from '@/_utils/utils';
import DownloadReportButton from '@/components/Focus/Reports/DownloadReportButton';
import { Button } from '@mui/material';

export default {
  name: {
    label: 'Name',
    render: (cell: FocusReport['name']) => <ClickCopy copyText={cell}>{cell}</ClickCopy>
  },
  created_at: {
    label: 'Created',
    render: (cell: FocusReport['created_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  created_by: {
    label: 'Created By',
    render: (cell: FocusReport['created_by']) => <UserDisplay user={cell} />
  },
  file_info__file_size: {
    label: 'File Size',
    disableSort: true,
    render: (cell: FocusReport['file_info']['file_size']) => formatBytes(cell)
  },
  id: {
    minWidth: 190,
    render: (id: FocusReport['id'], row: FocusReport) =>
      row.file_info?.file_size ? (
        <DownloadReportButton reportId={id} />
      ) : (
        <Button variant="contained" disabled>
          Generating
        </Button>
      )
  }
};
